// Minimum-viable theme provider for the migration. The legacy app set
// `forcedTheme="light"` via next-themes, so we hardcode light here and defer
// a real toggle UX to a follow-up. Apply the `light` class on <html> in
// __root.tsx via the inline blocking script so there's no FOUC.
import type { ReactNode } from "react";

export function ThemeProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
